import type { Person } from '@/store/people/types';
import { createContext, useContext } from 'react';
import type { PersonFieldKey } from '../people/people/fields';

export type Callback = {
  callback: (person: Person) => void;
};

export interface ProfileModalState {
  open: boolean;
  setOpen: (value: boolean) => void;
  currentPerson: Person | null;
  setCurrentPerson: (value: Person | null) => void;
  setOnUpdated: (value: Callback) => void;
  setFields: (fields?: PersonFieldKey[]) => void;
}

export const ProfileModalContext = createContext({} as ProfileModalState);

export function useProfileModal() {
  return useContext(ProfileModalContext);
}

export interface TagsModalState {
  open: boolean;
  setOpen: (value: boolean) => void;
  currentPerson: Person | null;
  setCurrentPerson: (value: Person | null) => void;
  setOnUpdated: (value: Callback) => void;
}

export const TagsModalContext = createContext({} as TagsModalState);

export function useTagsModal() {
  return useContext(TagsModalContext);
}
